import type { HTMLAttributes, ReactNode } from 'react'
import { memo } from 'react'

export function createWrapComponent(props: HTMLAttributes<HTMLDivElement>) {
  return memo(({ children }: { children: ReactNode }) => {
    return <div {...props}>{children}</div>
  })
}
